<app-header />
<div class="site-page">
<router-outlet />
</div>
<app-footer />